export const wholesaleTiers = [
  {
    id: "starter",
    name: "Starter case",
    who: "Trying it in one shop",
    units: "24 units",
    price: "$8.50",
    perks: ["All 3 characters (8 each)", "Countertop display included", "Ships in 3–5 days"],
  },
  {
    id: "shop",
    name: "Shop pack",
    who: "Shops and small chains",
    units: "96 units",
    price: "$7.50",
    perks: ["Choose your character mix", "2 displays + shelf talkers", "Net-30 after first order"],
    featured: true,
  },
  {
    id: "distributor",
    name: "Distributor",
    who: "Regional & national",
    units: "500+ units",
    price: "$5.00",
    perks: ["Master cartons", "Territory protection available", "First access to new series"],
  },
];

export const retailerReasons = [
  { title: "An everyday item people want to show off", text: "Pill crushers usually look medical. This one has a face, so people pick it up at the register." },
  { title: "Exactly 2× markup", text: "At $14.99 retail, the shop pack gives you a clean 2× markup, and it's small enough to be an impulse buy." },
  { title: "Limited series bring people back", text: "One series at a time, each with 3 characters. Customers collect them and come back for the next drop." },
];

export const businessTypes = ["Smoke shop", "Head shop chain", "Pharmacy / wellness", "Gift or novelty store", "Distributor", "Other"];
